import Int32LookupRequestModelBase from '../_generated/modelBases/int32-lookup-request-model-base';

export default class Int32LookupRequestModel extends Int32LookupRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
